<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent" validationCollectionName="artifact"></validation-results>
<h2>&nbsp;<button type="button" class="icon--add btn--default" (click)="launchDocumentsModal()">Add Documents</button></h2>
<table class="mvd_table--primeng" *ngIf="dataLoaded">
    <thead>
        <tr>
            <th>Service Artifact</th>
            <th>Service</th>
            <th>Customer</th>
            <th class="w--actions">Actions</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let trans of transactionRows;">
            <td>{{trans.documentTypeDisplayValue}}</td>
            <td>{{service}}</td>
            <td>{{customer}}</td>
            <td>
                <a href="javascript:void(0)" class="icon--download" title="Download to Print" (click)="downloadDocument(trans.documentId)"
                   *ngIf="!trans.isDocumentViewRestricted"></a>
                <a href="javascript:void(0)" class="icon--delete" title="Delete Document" (click)="deleteDocument(trans.documentRequirementId)"
                   *ngIf="trans.isAllowDeleteScannedDocuments"></a>
            </td>
        </tr>
    </tbody>
</table>

<div class="well__footer">
    <button class="btn--icon btn--primary" *ngIf="displayCompleteAllButton" [disabled]="completeAllButtonDisabled" (click)="completeAllTransactions()"><i class="material-icons">refresh</i>Complete Remaining Transactions</button>
    <div *ngIf="noArtifact">
        <p class="mvd_alert--label">No Artifacts to Display.</p>
    </div>
    <div *ngIf="this.completeAllCount != 0 && !completeAllTransactionComplete">
        <span class="mvd_alert--message__info">Pending Transactions completed {{this.completeAllCount}}</span>
    </div>
    <div *ngIf="completeAllTransactionComplete">
        <span class="mvd_alert--message__info">All remaining transactions have been completed. Total completed {{this.completeAllCount}}</span>
    </div>
    <div *ngIf="finalizeError">
        <span class="mvd_alert--message__warning">An error occured attempting to finalize one or more services.</span>
    </div>
</div>
